module.exports = require('./helpers/bundle-url').getBundleURL('kM8PK') + "logo.c51670a8.svg";